import React, { useState } from "react";
import {
  Block,
  BlockContent,
  BlockDes,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Icon,
  LinkItem,
  PreviewCard,
} from "../../components/Component";
import Logo from "../../images/logo.svg";
import LogoDark from "../../images/logo-dark.svg";
import PageContainer from "../../layout/page-container/PageContainer";
import Head from "../../layout/head/Head";
import AuthFooter from "./AuthFooter";
import { useLocation, Link } from "react-router-dom";
import { generateSession, resendVerifyEmail } from "./AuthData";
import { Alert, Spinner } from "reactstrap";
import { Storage } from "../../services/storage/storage";

export const ConfirmationType = {
  email: "email",
  forgotPassword: "forgot password",
  createPassword: "create password",
};

const ConfirmationPage = () => {
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [errorVal, setError] = useState(null);

  function resendEmail() {
    setLoading(true);
    let params = {
      email: location.state.email,
      tokenType:
        location.state.type === ConfirmationType.email
          ? "VERIFY_EMAIL"
          : "RESET_PASSWORD",
    };
    resendVerifyEmail(params, (_, error) => {
      setLoading(false);
      if (error !== null) {
        setError(error.message);
      }
    });
  }

  function fetchSessionData() {
    setLoading(true);
    let params = { token: location.state.token };
    generateSession(params, (auth, error) => {
      setLoading(false);
      if (error === null) {
        Storage.setLastSignedInTime(Date.now());
        Storage.setIsStaySignedIn(false);
      } else {
        Storage.clearAll();
      }
      checkAndLoad();
    });
  }

  function checkAndLoad() {
    window.history.pushState(
      `${process.env.PUBLIC_URL ? process.env.PUBLIC_URL : "/"}`,
      "auth-login",
      `${process.env.PUBLIC_URL ? process.env.PUBLIC_URL : "/"}`
    );
    window.location.reload();
  }

  return (
    <React.Fragment>
      <Head title="Confirmation" />
      <PageContainer>
        <Block className="nk-block-middle nk-auth-body  wide-xs">
          <div className="brand-logo pb-4 text-left mx-4">
            <Link to={process.env.PUBLIC_URL + "/"} className="logo-link">
              <img
                className="logo-light logo-img logo-img-lg"
                src={Logo}
                alt="logo"
              />
              <img
                className="logo-dark logo-img logo-img-lg"
                src={LogoDark}
                alt="logo-dark"
              />
            </Link>
          </div>
          <PreviewCard className="card-bordered" bodyClass="card-inner-lg">
            {location.state.type === ConfirmationType.email ? (
              <EmailConfirmationView
                email={location.state.email}
                error={errorVal}
                loading={loading}
                onOpenMail={() => {
                  window.open(process.env.REACT_APP_CONTACT_US_MAIL);
                }}
                onResend={() => {
                  resendEmail();
                }}
              />
            ) : location.state.type === ConfirmationType.forgotPassword ? (
              <ForgotPasswordConfirmationView onResend={() => resendEmail()} />
            ) : location.state.type === ConfirmationType.createPassword ? (
              <CreatePasswordConfirmationView
                loading={loading}
                onDashboard={() => fetchSessionData()}
              />
            ) : null}
          </PreviewCard>
        </Block>
        <div className="gap-100px" />
        <AuthFooter />
      </PageContainer>
    </React.Fragment>
  );
};
export default ConfirmationPage;

const EmailConfirmationView = ({
  email,
  error,
  loading,
  onOpenMail,
  onResend,
}) => {
  return (
    <React.Fragment>
      <BlockHead>
        <BlockContent>
          <BlockTitle tag="h5">First, let's verify your email</BlockTitle>
          <BlockDes>
            <br />
            <p>
              Check <strong>{email}</strong> to verify your account and get
              started.
            </p>
            <p>
             If you did not receive the email from us, resend it.
            </p>
          </BlockDes>
        </BlockContent>
      </BlockHead>
      {error && (
        <div className="mb-3">
          <Alert color="danger" className="alert-icon">
            {" "}
            <Icon name="alert-circle" /> {error}{" "}
          </Alert>
        </div>
      )}
      <BlockHeadContent>
        <Button className="btn" color="primary" disabled={loading} onClick={onResend}>
          {loading ? <Spinner size="sm" color="lighter" /> : "Resend email"}
        </Button>
      </BlockHeadContent>
      <p className="mt-2">
        Need help?{" "}
        <Button className="text-primary fw-normal ms-n3 fSize14" onClick={() => onOpenMail()}>
          Contact us.
        </Button>
      </p>
    </React.Fragment>
  );
};

const ForgotPasswordConfirmationView = ({ onResend }) => {
  return (
    <React.Fragment>
      <BlockHead>
        <BlockContent>
          <BlockTitle tag="h5">
            Thanks, check your email for instructions to reset your password
          </BlockTitle>
          <BlockDes>
            <br />
            <p>
              If you haven't received an email in 5 minutes, check your spam or{" "}
              <a href={undefined} id="#cannot" className="text-azure" onClick={onResend} style={{cursor: "pointer"}}>
                resend
              </a>
              .
            </p>
          </BlockDes>
        </BlockContent>
      </BlockHead>
    </React.Fragment>
  );
};

const CreatePasswordConfirmationView = ({ loading, onDashboard }) => {
  return (
    <React.Fragment>
      <BlockHead>
        <BlockContent>
          <BlockTitle tag="h5">
            You've successfully changed your password
          </BlockTitle>
        </BlockContent>
      </BlockHead>
      <BlockHeadContent>
        <Button color="primary" className="center" onClick={onDashboard}>
          {loading ? <Spinner size="sm" color="dark" /> : "Continue"}
        </Button>
      </BlockHeadContent>
    </React.Fragment>
  );
};
